import Api from '@/services/api';

export default {
  /**
   * Login request should not be canceled to avoid hanging promises
   * when the request is aborted (e.g., due to navigation).
   * See: https://github.com/axios/axios#cancellation
   */
  login(user) {
    return Api(false, false)
      .post('/token', user)
      .then((res) => res.data);
  },

  /**
   * Same reason as login: prevent cancellation that leads to unresolved promises.
   */
  refresh(refreshToken) {
    return Api(false, false)
      .post('/refreshToken', refreshToken)
      .then((res) => res.data);
  },

  verifyTotp(payload) {
    return Api(false, false)
      .post('/token/verify-totp', payload)
      .then((res) => res.data);
  },

  registerOtpPhone(payload) {
    return Api(false, false)
      .post('/token/register-phone', payload)
      .then((res) => res.data);
  },
};
